var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgImportEnrichmentsPlaceholder = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "419px",
    height: "286px",
    viewBox: "0 0 419 286",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "135CE7CB-649B-4566-BEE8-B35D31E65BE8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "overrides-4---only-download/upload",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "V4-Overwrites",
    transform: "translate(-1262.000000, -333.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "undraw_file_sync_ot38",
    transform: "translate(1262.000000, 333.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M203.758883,14.3310481 L203.276649,14.3310481 L203.276649,13.480917 L203.638323,13.480917 C203.771486,13.480911 203.879434,13.3721648 203.87944,13.2380177 L203.87944,8.86581693 C203.879438,8.73166821 203.771487,8.62291968 203.638323,8.62291769 L203.276649,8.62291769 L203.276649,6.13988869 C203.276654,4.73695761 202.723433,3.39148577 201.738689,2.39946505 C200.753945,1.40744432 199.418345,0.850136926 198.025708,0.850145543 L197.489849,0.850145543 L197.489849,0.242899242 C197.489849,0.108749695 197.381897,0 197.248732,0 L192.908629,0 C192.775464,0 192.667512,0.108749695 192.667512,0.242899242 L192.667512,0.850145543 L114.250941,0.850145543 C112.858305,0.850136926 111.522705,1.40744432 110.537961,2.39946505 C109.553217,3.39148577 109,4.73695761 109,6.13988869 L109,118.710242 C109,120.113175 109.553216,121.458648 110.53796,122.450671 C111.522703,123.442694 112.858304,124 114.250941,124 L198.025708,124 C199.418346,124 200.753946,123.442694 201.73869,122.450671 C202.723433,121.458648 203.276654,120.113175 203.276649,118.710242 L203.276649,19.1890293 L203.758883,19.1890293 C203.892046,19.1890233 204,19.0802771 204,18.9461301 L204,14.5739401 C204,14.4397942 203.892045,14.3310501 203.758883,14.3310481 Z",
    id: "Path",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F2F2F2",
    x: 113,
    y: 4,
    width: 87,
    height: 115
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3F3D56",
    x: 0,
    y: 241,
    width: 419,
    height: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9707851,205.272446 C98.7841303,233.1567 82.5113612,243.375661 62.0895013,243.972793 C61.6151376,243.986664 61.1429063,243.995165 60.6728074,243.998298 C59.7257506,244.005526 58.7878934,243.989736 57.8592356,243.950927 C39.389709,243.183248 24.7700032,233.367243 24.0135961,207.43495 C23.2308053,180.59824 56.5002959,145.729149 58.9964284,143.149868 C58.9986733,143.149803 58.9986733,143.149803 59.0008783,143.147461 C59.0957003,143.049172 59.1442609,143 59.1442609,143 C59.1442609,143 97.1575015,177.390455 97.9707851,205.272446 Z",
    id: "Path",
    fill: "#FF5722"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7964281,239.74672 L73.4027632,220.430678 L60.8222113,241.824757 L60.8485161,243.998298 C59.9282034,244.005526 59.0168305,243.989735 58.1143974,243.950925 L58.7396435,216.011499 L58.7225158,215.795957 L58.7455853,215.75431 L58.8054301,213.114205 L45,192.461799 L58.7891376,211.138235 L58.8380715,211.696273 L59.310317,190.586944 L47.3861583,169.175134 L59.344287,186.878644 L59.2194697,143.145561 L59.2197375,143 L59.2237939,143.143153 L60.0153339,177.610708 L70.8827868,163.609968 L60.0509109,180.580012 L60.288091,199.461815 L70.2883811,181.033892 L60.3248415,202.237764 L60.4568765,212.736995 L75,187.067119 L60.5010878,216.399723 L60.7964281,239.74672 Z",
    id: "Path",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312,38.2884595 L311.471074,38.2884595 L311.471074,23.5374794 C311.471077,21.2731966 310.587525,19.101652 309.01479,17.500563 C307.442054,15.899474 305.308967,15 303.084784,15 L272.386301,15 C270.162116,15 268.029026,15.8994711 266.456289,17.5005603 C264.883551,19.1016494 264,21.2731951 264,23.5374794 L264,104.462521 C264,106.726805 264.883551,108.898351 266.456289,110.49944 C268.029026,112.100529 270.162116,113 272.386301,113 L303.084784,113 C305.308968,113 307.442057,112.100529 309.014794,110.49944 C310.587531,108.89835 311.471084,106.726805 311.471081,104.462521 L311.471081,48.7884628 L312,48.7884628 L312,38.2884595 Z",
    id: "Path",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310,23.4047946 L310,104.592928 C310.000595,108.130831 307.156369,111 303.647221,111 L272.352754,111 C268.84361,111 265.999393,108.130826 266,104.592928 L266,23.4047946 C266,19.8676747 268.844382,17 272.352754,17 L276.149499,17 C275.770068,17.9383497 275.878826,19.0055575 276.439586,19.8465161 C277.000346,20.6874747 277.939526,21.191837 278.94462,21.1917791 L296.786908,21.1917791 C297.792006,21.1918483 298.731193,20.6874876 299.291953,19.8465245 C299.852713,19.0055614 299.961462,17.938347 299.582014,17 L303.647221,17 C307.155598,17 310,19.8676698 310,23.4047946 Z",
    id: "Path",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#CCCCCC",
    x: 279,
    y: 29,
    width: 27,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#CCCCCC",
    x: 279,
    y: 32,
    width: 27,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#CCCCCC",
    x: 279,
    y: 35,
    width: 27,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#CCCCCC",
    x: 271,
    y: 29,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#CCCCCC",
    x: 279,
    y: 99,
    width: 27,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#CCCCCC",
    x: 279,
    y: 101,
    width: 27,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#CCCCCC",
    x: 279,
    y: 105,
    width: 27,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#CCCCCC",
    x: 271,
    y: 99,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.912816,137.540542 L227.705881,137.540542 L227.705881,136 L193.60413,136 L193.60413,137.540542 L118.087184,137.540542 C116.737979,137.54054 115.444033,138.073211 114.490001,139.021371 C113.535969,139.969532 113,141.255515 113,142.596417 L113,244.944103 C113,247.736393 115.277605,250 118.087184,250 L302.912816,250 C305.722395,250 308,247.736393 308,244.944103 L308,142.596417 C308,141.255515 307.464031,139.969532 306.509999,139.021371 C305.555967,138.073211 304.262021,137.54054 302.912816,137.540542 Z",
    id: "Path",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F2F2F2",
    x: 119,
    y: 147,
    width: 182,
    height: 102
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FF5722",
    cx: 210.5,
    cy: 141.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.929071,247.490012 L295.222215,247.490012 L295.222215,246.246552 C295.222218,246.181162 295.195568,246.11845 295.14813,246.072212 C295.100691,246.025974 295.03635,246 294.969261,246 L288.898339,246 C288.83125,246 288.766909,246.025974 288.71947,246.072212 C288.672032,246.11845 288.645382,246.181162 288.645385,246.246552 L288.645385,247.490012 L284.851055,247.490012 L284.851055,246.246552 C284.851058,246.181162 284.824408,246.11845 284.77697,246.072212 C284.729531,246.025974 284.665189,246 284.598101,246 L278.527179,246 C278.46009,246 278.395749,246.025974 278.34831,246.072212 C278.300871,246.11845 278.274222,246.181162 278.274225,246.246552 L278.274225,247.490012 L274.479894,247.490012 L274.479894,246.246552 C274.479897,246.181162 274.453248,246.11845 274.405809,246.072212 C274.358371,246.025974 274.294029,246 274.22694,246 L268.156022,246 C268.088933,246 268.024592,246.025974 267.977153,246.072212 C267.929715,246.11845 267.903065,246.181162 267.903068,246.246552 L267.903068,247.490012 L264.108734,247.490012 L264.108734,246.246552 C264.108737,246.181162 264.082088,246.11845 264.034649,246.072212 C263.98721,246.025974 263.922869,246 263.85578,246 L257.784866,246 C257.717776,246 257.653434,246.025972 257.605994,246.07221 C257.558555,246.118449 257.531905,246.181162 257.531908,246.246552 L257.531908,247.490012 L253.737588,247.490012 L253.737588,246.246552 C253.737591,246.181162 253.710941,246.118449 253.663502,246.07221 C253.616062,246.025972 253.55172,246 253.48463,246 L247.413705,246 C247.346616,246 247.282275,246.025974 247.234836,246.072212 C247.187398,246.11845 247.160748,246.181162 247.160751,246.246552 L247.160751,247.490012 L243.366421,247.490012 L243.366421,246.246552 C243.366424,246.181162 243.339774,246.11845 243.292336,246.072212 C243.244897,246.025974 243.180555,246 243.113467,246 L237.042549,246 C236.97546,246 236.911118,246.025974 236.86368,246.072212 C236.816241,246.11845 236.789592,246.181162 236.789594,246.246552 L236.789594,247.490012 L232.995264,247.490012 L232.995264,246.246552 C232.995267,246.181162 232.968617,246.11845 232.921179,246.072212 C232.87374,246.025974 232.809399,246 232.74231,246 L185.186758,246 C185.119669,246 185.055327,246.025974 185.007889,246.072212 C184.96045,246.11845 184.933801,246.181162 184.933804,246.246552 L184.933804,247.490012 L181.139473,247.490012 L181.139473,246.246552 C181.139476,246.181162 181.112827,246.11845 181.065388,246.072212 C181.017949,246.025974 180.953608,246 180.886519,246 L174.815601,246 C174.748512,246 174.684169,246.025972 174.63673,246.07221 C174.58929,246.118449 174.562641,246.181162 174.562643,246.246552 L174.562643,247.490012 L170.768313,247.490012 L170.768313,246.246552 C170.768315,246.181162 170.741665,246.118449 170.694225,246.072211 C170.646786,246.025974 170.582444,246 170.515355,246 L164.444441,246 C164.377352,246 164.31301,246.025974 164.265572,246.072212 C164.218133,246.11845 164.191484,246.181162 164.191487,246.246552 L164.191487,247.490012 L160.397156,247.490012 L160.397156,246.246552 C160.397159,246.181162 160.37051,246.11845 160.323071,246.072212 C160.275632,246.025974 160.211291,246 160.144202,246 L154.073284,246 C154.006195,246 153.941854,246.025974 153.894415,246.072212 C153.846977,246.11845 153.820327,246.181162 153.82033,246.246552 L153.82033,247.490012 L150.026,247.490012 L150.026,246.246552 C150.026002,246.181162 149.999352,246.118449 149.951913,246.07221 C149.904474,246.025972 149.840131,246 149.773042,246 L143.702124,246 C143.635035,246 143.570693,246.025974 143.523255,246.072212 C143.475816,246.11845 143.449167,246.181162 143.44917,246.246552 L143.44917,247.490012 L139.654839,247.490012 L139.654839,246.246552 C139.654842,246.181162 139.628193,246.11845 139.580754,246.072212 C139.533315,246.025974 139.468974,246 139.401885,246 L133.330967,246 C133.263878,246 133.199537,246.025974 133.152098,246.072212 C133.10466,246.11845 133.07801,246.181162 133.078013,246.246552 L133.078013,247.490012 L129.283682,247.490012 L129.283682,246.246552 C129.283685,246.181162 129.257036,246.11845 129.209597,246.072212 C129.162159,246.025974 129.097817,246 129.030728,246 L122.95981,246 C122.892721,246 122.828378,246.025972 122.780939,246.07221 C122.7335,246.118449 122.70685,246.181162 122.706853,246.246552 L122.706853,247.490012 L111.070922,247.490012 C107.718045,247.490014 105,250.139231 105,253.407205 L105,256.082822 C105,259.350791 107.71805,262 111.070922,262 L312.929071,262 C316.281946,262 319,259.350794 319,256.082822 L319,253.407205 C319,251.837867 318.360385,250.332805 317.221865,249.223116 C316.083345,248.113428 314.539181,247.490011 312.929071,247.490012 Z",
    id: "Path",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E6E6E6",
    x: 193,
    y: 154,
    width: 51,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E6E6E6",
    x: 193,
    y: 160,
    width: 51,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E6E6E6",
    x: 193,
    y: 166,
    width: 51,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#CCCCCC",
    x: 193,
    y: 154,
    width: 51,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#CCCCCC",
    x: 193,
    y: 160,
    width: 51,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#CCCCCC",
    x: 193,
    y: 166,
    width: 51,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#CCCCCC",
    x: 177,
    y: 156,
    width: 11,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#CCCCCC",
    x: 193,
    y: 222,
    width: 51,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#CCCCCC",
    x: 193,
    y: 228,
    width: 51,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#CCCCCC",
    x: 193,
    y: 234,
    width: 51,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#CCCCCC",
    x: 177,
    y: 223,
    width: 11,
    height: 11
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.98271,111.795951 C330.02869,108.543761 326.053254,106.423495 321.72974,105.794271 L323.580544,104.1045 L321.533074,104 L319,106.314034 L321.289556,108.874211 L323.337027,108.978714 L321.802927,107.264301 C330.846957,108.740192 337.252043,116.990393 336.519155,126.219834 C335.786267,135.449276 328.161293,142.561431 319,142.560611 L319,144 C326.540903,144 333.367923,139.492561 336.39811,132.513569 C339.428297,125.534578 338.088084,117.404922 332.98271,111.795951 L332.98271,111.795951 Z",
    id: "Path",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.0172896,111.795951 C87.971311,108.543761 91.9467482,106.423494 96.2702639,105.794271 L94.419456,104.1045 L96.4669263,104 L99,106.314034 L96.7104437,108.874211 L94.6629734,108.978714 L96.1970727,107.264301 C87.1530434,108.740192 80.7479568,116.990393 81.4808446,126.219834 C82.2137325,135.449276 89.838707,142.561431 99,142.560611 L99,144 C91.4590969,144 84.6320775,139.492561 81.6018902,132.513569 C78.571703,125.534578 79.9119161,117.404922 85.0172896,111.795951 L85.0172896,111.795951 Z",
    id: "Path",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#CCCCCC",
    x: 139,
    y: 10,
    width: 51,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#CCCCCC",
    x: 139,
    y: 16,
    width: 51,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#CCCCCC",
    x: 139,
    y: 22,
    width: 51,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#CCCCCC",
    x: 123,
    y: 11,
    width: 11,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#CCCCCC",
    x: 139,
    y: 100,
    width: 51,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#CCCCCC",
    x: 139,
    y: 106,
    width: 51,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#CCCCCC",
    x: 139,
    y: 112,
    width: 51,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#CCCCCC",
    x: 123,
    y: 102,
    width: 11,
    height: 11
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.102199,118.887529 L360.444276,101.952175 C360.444276,101.952175 370.320758,93.8077281 367.490008,92.2218829 C364.659258,90.6360376 357.24816,98.0708213 357.24816,98.0708213 C357.24816,98.0708213 335.866831,114.928473 339.392608,117.281192 C342.918385,119.633911 349.102199,118.887529 349.102199,118.887529 Z",
    id: "Path",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350,96 L365.220969,96 C366.259677,90.3751006 366.259677,84.6248994 365.220969,79 L350,79 C351.714764,84.5528363 351.714764,90.4471637 350,96 L350,96 Z",
    id: "Path",
    fill: "#FF5722"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.428703,97.0271545 C383.966965,89.3849859 375.139755,89.028827 375.139755,89.028827 C375.139755,89.028827 366.538158,87.9138149 361.020288,99.5529374 C355.877193,110.401549 348.779067,120.876103 359.877559,123.415685 L361.882278,117.090725 L363.123784,123.886581 C364.703993,124.001792 366.289238,124.029256 367.872409,123.968852 C379.757989,123.579862 391.077204,124.082659 390.712742,119.759226 C390.228245,114.011801 392.721789,104.380444 388.428703,97.0271545 Z",
    id: "Path",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.660378,144 L359,156.91228 L378.811322,160 C378.811322,160 388.150942,147.368422 389,146.526316 L364.660378,144 Z",
    id: "Path",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFB8B8",
    cx: 374,
    cy: 104.5,
    rx: 11,
    ry: 10.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372,111.860769 C372,111.860769 377,122.731689 376.411764,123.875994 C375.823528,125.0203 387,117.868383 387,117.868383 C387,117.868383 382.294118,110.144309 382.588236,109 L372,111.860769 Z",
    id: "Path",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.927898,116.846755 C387.927898,116.846755 396.549958,112.040906 401.435796,125.327668 C401.435796,125.327668 417.530312,143.985675 414.656291,147.378041 C411.78227,150.770406 400.860991,139.179825 400.860991,139.179825 L393.963339,132.112396 C393.963339,132.112396 384.19167,129.568123 385.053877,124.196878 C385.916085,118.825634 387.927898,116.846755 387.927898,116.846755 Z",
    id: "Path",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.78999,123.181055 L348.121049,117.514662 C348.121049,117.514662 337.72461,113.264869 338.005595,115.814763 C338.28658,118.364658 357.112565,132.813939 363.294233,131.963979 C369.475901,131.114019 367.78999,123.181055 367.78999,123.181055 Z",
    id: "Path",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.945916,121.588711 C379.945916,121.588711 373.241971,120.728916 371.784594,122.161907 C370.327216,123.594898 367.558194,122.30521 367.558194,122.30521 L362.894579,130.616665 C362.894579,130.616665 359.542608,135.345585 362.16589,139.931209 C364.789172,144.516834 361,150.53546 361,150.53546 C361,150.53546 381.986257,150.53546 386.358393,152.828271 C390.730529,155.121081 396,133.697213 396,133.697213 C396,133.697213 390.584792,127.177454 392.042173,123.165033 C393.499554,119.152612 392.625118,116 392.625118,116 L386.212649,116.573196 L379.945916,121.588711 Z",
    id: "Path",
    fill: "#D0CDE1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFB8B8",
    points: "355 248.662625 357.256692 270 366 265.566332 363.179578 247"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFB8B8",
    points: "389 248.485388 396.651771 268 404 262.953938 394.878953 244"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.111167,258 C364.670925,259.643939 364.011191,261.215266 363.151312,262.6679 C361.751413,265.001849 358.391658,263.834862 358.391658,263.834862 C358.391658,263.834862 354.471947,260.625679 353.632008,262.084397 C352.792068,263.543114 348.312398,270.836711 348.312398,270.836711 C348.312398,270.836711 333.473488,283.673437 346.072563,285.715646 C358.671638,287.757856 361.191453,278.130305 361.191453,278.130305 C361.191453,278.130305 370.710757,274.629382 370.990736,271.128455 C371.270716,267.627529 365.111167,258 365.111167,258 Z",
    id: "Path",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.234401,262.556576 C396.234401,262.556576 391.731215,261.108625 392.012664,263.425346 C392.294113,265.742067 393.982806,275.009082 393.982806,275.009082 C393.982806,275.009082 390.88687,288.040782 399.611786,285.724036 C408.336703,283.40729 408.618156,270.954773 408.618156,270.954773 C408.618156,270.954773 413.121339,254.447951 409.743939,254.15836 C406.36654,253.86877 398.204533,253 398.204533,253 C398.204533,253 403.270625,261.398204 396.234401,262.556576 Z",
    id: "Path",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#2F2E41",
    points: "386.596589 96.612833 378.122868 92 366.421163 93.887167 364 105 370.026712 104.758977 371.710209 100.676467 371.710209 104.691824 374.491124 104.580388 376.105116 98.0807505 377.114167 105 387 104.790194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.004539,159.449555 L358.817585,154 C358.817585,154 346.724106,174.650948 344.996468,191.860067 C343.268829,209.069187 335.494448,250.371083 347.875867,250.944717 C360.257286,251.518352 367.45578,251.518348 368.03166,250.371086 C368.607541,249.223824 361.984921,203.906458 361.984921,203.906458 C361.984921,203.906458 376.093978,259.549282 383.868356,255.820642 C391.642734,252.092001 400.280932,247.21608 399.992992,244.347893 C399.705052,241.479706 380.988956,211.076938 380.988956,211.076938 L383.580416,184.689619 C383.580416,184.689619 386.747756,174.077328 381.276897,164.325494 L383.004539,159.449555 Z",
    id: "Path",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365,151 L380.220969,151 C381.259677,145.375101 381.259677,139.624899 380.220969,134 L365,134 C366.714761,139.552837 366.714761,145.447163 365,151 Z",
    id: "Path",
    fill: "#FF5722"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.039253,138.688906 L383.578261,138.112863 C383.578261,138.112863 372.294412,129.472125 372.005086,134.656567 C371.715759,139.841009 383.867591,142.721255 383.867591,142.721255 C383.867591,142.721255 409.991533,152.053306 414,147.963331 L409.039253,138.688906 Z",
    id: "Path",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FF5722",
    cx: 135.5,
    cy: 62.5,
    r: 8.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FF5722",
    cx: 158,
    cy: 62,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FF5722",
    cx: 181.5,
    cy: 62.5,
    r: 4.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FF5722",
    cx: 277.5,
    cy: 64.5,
    r: 4.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FF5722",
    cx: 289.5,
    cy: 64.5,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FF5722",
    cx: 302,
    cy: 64,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FF5722",
    cx: 209.5,
    cy: 193.5,
    r: 20.5
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#D0CDE1",
    points: "217 198.534957 209.480561 183 202 198.554841 206.226985 198.549318 206.226985 205 212.769775 205 212.769775 198.54048"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgImportEnrichmentsPlaceholder);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/import-enrichments-placeholder.ec5bebf24bafdd0a6265e05c238e8d5f.svg";